import contentStudioInstance from '@/utils/axiosContentStudio';

const subscriptionUpdaters = {
  updateAutoRenewalStatus: async (
    payment_source_id: string,
    is_enabled: boolean
  ) => {
    const response = await contentStudioInstance.put(
      '/api/v1/subscriptions/auto-renewal-status',
      {
        payment_source_id,
        is_enabled,
      }
    );
    return response.data;
  },

  changeSubscription: async (
    payment_source_id: string,
    plan_id: string,
    is_dry_run: boolean
  ) => {
    const response = await contentStudioInstance.put(
      '/api/v1/subscriptions/change-plan',
      {
        payment_source_id,
        plan_id,
        is_dry_run,
      }
    );
    return response.data;
  },
};

export default subscriptionUpdaters;
